import gql from "graphql-tag";
import { taskInternalPartnerFileTypeDef } from "../definitions/task-internal-partner-file-type-def";
import { errorsTypeDef } from "../../errors/errors-type-def";

const uploadInternalPartnerTaskFileMutation = gql`
  mutation taskInternalPartnerFileUpload (
  $taskId: String!
  $name: String!
  $content: String!
  $extension: String!
  ) {
    taskInternalPartnerFile{
      upload(input: {
        taskId: $taskId
        file: {
          name: $name
          content: $content
          extension: $extension
        }
      }) {
        output {
          ${taskInternalPartnerFileTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }
  }`;

export default uploadInternalPartnerTaskFileMutation;
